//////////////////////////////////////////////////////////////////////////////
//
//  CommonCode API
//
//  작성자: MediInStep Team
//  생성일: 2025-01-XX
//
//  설명: 공통코드 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 공통코드 관련 API
 */
const CommonCodeAPI: ApiGroup = {
  getGroups: {
    title: "공통코드 그룹 목록 조회",
    url: "/CommonCode/GetGroups",
    method: "GET",
    paramz: {},
  },
  getByGroup: {
    title: "그룹 코드로 공통코드 조회",
    url: "/CommonCode/:groupCode",
    method: "GET",
    pathParams: ["groupCode"],
    paramz: {},
  },
  getAll: {
    title: "전체 공통코드 조회",
    url: "/CommonCode",
    method: "GET",
    paramz: {},
  },
  pagedList: {
    title: "공통코드 페이지 목록 조회",
    url: "/CommonCode/PagedList",
    method: "POST",
    paramz: {
      pageNumber: 1,
      pageSize: 10,
      groupCode: "",
      code: "",
      name: "",
      isActive: null,
    },
  },
  getById: {
    title: "공통코드 단건 조회",
    url: "/CommonCode/GetById/:seqId",
    method: "GET",
    pathParams: ["seqId"],
    paramz: {},
  },
  create: {
    title: "공통코드 생성",
    url: "/CommonCode/Create",
    method: "POST",
    paramz: {
      groupCode: "",
      code: "",
      name: "",
      description: "",
      sortOrder: 0,
      extraValue1: "",
      extraValue2: "",
      extraValue3: "",
      isActive: true,
    },
  },
  update: {
    title: "공통코드 수정",
    url: "/CommonCode/Update/:seqId",
    method: "PUT",
    pathParams: ["seqId"],
    paramz: {
      seqId: 0,
      groupCode: "",
      code: "",
      name: "",
      description: "",
      sortOrder: 0,
      extraValue1: "",
      extraValue2: "",
      extraValue3: "",
      isActive: true,
    },
  },
  delete: {
    title: "공통코드 삭제",
    url: "/CommonCode/Delete/:seqId",
    method: "DELETE",
    pathParams: ["seqId"],
    paramz: {},
  },
}

export default CommonCodeAPI


